module.exports = __webpack_public_path__ + "static/banner-johannie-desktop-c8800a5fb01d957302d67eb7e4ec7efb.jpg";